import React, { FC } from 'react';
import cx from 'classnames';
import Dropdown from '../Dropdown/Dropdown';
import TerritoryMembershipDropdownMenu from './TerritoryMembershipDropdownMenu';
import DropdownLabel from '../Dropdown/DropdownLabel';
import ChevronIcon from '../Navbar/ChevronIcon';
import { TDropdownState } from '../Dropdown/types';
import { getFeatureFlag } from '../FeatureFlags/getFeatureFlag';
import { useTerritoryHomePageContext } from '../TerritoryHomePageContext/TerritoryHomePageContextProvider';
import { TerritoryVersionType } from '../../layouts/TerritoryPageLayout/TerritoryPageLayout';

type TTerritoryMembershipMenuProps = {
  onLeaveTerritoryButtonClick: () => void;
  onStateChange: (state: TDropdownState) => void;
  territoryId: string;
  isTerritoryMember: boolean;
  isTerritoryAdmin: boolean;
  canUpdateTerritory: boolean;
  canUpdateTerritoryGlobally: boolean;
  territorySlug: string;
};

const TerritoryMembershipMenu: FC<TTerritoryMembershipMenuProps> = ({
  onLeaveTerritoryButtonClick,
  onStateChange,
  territoryId,
  isTerritoryMember,
  isTerritoryAdmin,
  canUpdateTerritory,
  canUpdateTerritoryGlobally,
  territorySlug,
}) => {
  if (!isTerritoryMember && !isTerritoryAdmin) {
    return null;
  }
  const { territoryVersion } = useTerritoryHomePageContext();
  const isTerritoryPageV2 = getFeatureFlag('territoryPageV2');
  const adminLabel = (isTerritoryAdmin || canUpdateTerritoryGlobally) && 'Admin';
  const memberLabel = isTerritoryMember && 'Member';

  if (
    isTerritoryMember &&
    !isTerritoryAdmin &&
    !canUpdateTerritoryGlobally &&
    territoryVersion === TerritoryVersionType.V2
  ) {
    return (
      <DropdownLabel
        label={memberLabel}
        withBorder
        className="text-center h-10 rounded-[8px] !border !border-t2-neutral-grey01 hover:!bg-transparent"
      />
    );
  }

  return (
    <Dropdown
      onStateChange={onStateChange}
      menuContainerClassName={cx({
        'max-w-none md:!w-[210px] lg:!w-[300px] border border-t2-neutral-grey03': isTerritoryPageV2,
      })}
      dropdownButtonClassName="!w-full"
      renderLabel={({ isOpen }) => (
        <DropdownLabel
          labelClassName={cx({
            '!w-fit': isTerritoryPageV2,
          })}
          rightAdornment={
            <ChevronIcon
              className={cx('mr-1 ml-2 stroke-black-700', {
                'scale-y-1 transition-transform duration-200': !isOpen,
                'scale-y-[-1] transition-transform duration-200': isOpen,
              })}
              height={6}
              width={12}
            />
          }
          withBorder
          className={cx({
            'h-10 rounded-[8px] !border !border-t2-neutral-grey01': isTerritoryPageV2,
          })}
          label={<span>{adminLabel || memberLabel}</span>}
          isActive={isOpen}
        />
      )}
      menu={
        <TerritoryMembershipDropdownMenu
          territoryId={territoryId}
          onLeaveTerritoryButtonClick={onLeaveTerritoryButtonClick}
          territorySlug={territorySlug}
          canUpdateTerritory={canUpdateTerritory}
          isTerritoryMember={isTerritoryMember}
          isTerritoryAdmin={isTerritoryAdmin}
        />
      }
    />
  );
};

export default TerritoryMembershipMenu;
